import React from 'react';
import clsx from 'clsx';

import { parseVideoUrl } from 'utils/urls';
import { MediaEmbedVideo } from './MediaEmbedVideo';

const providersRatio = {
  youtube: .562061,
  vimeo: .5625,
  youku: .5625,
  dailymotion: .560417,
  coub: .5125,
  youtubeShorts: 1.7778,
};

export const mediaEmbedPlugin = {
  options: {
    rules: [
      {
        parser: parseVideoUrl,
        component: MediaEmbedVideo,
      },
    ],
  },
  then: () => ({
    serializeHtml: (props) => {
      const { element } = props;
      const { url, caption, align = 'left', width } = element;
      const fullWidth = width === '100%';
      const data = parseVideoUrl(url);
      const { url: embedUrl, provider } = data;
      const ratio = provider ? providersRatio[provider] : 56.2061;
      const height = width === '100%' ? null : width * ratio;

      const figureStyle = { textAlign: align };

      const wrapperStyle = fullWidth ? {
        paddingBottom: `${ratio * 100}%`,
        width: '100%',
        position: 'relative',
        height: 0,
      } : {};

      const style = fullWidth ? {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      } : {
        height,
        width,
      };

      return (
        <figure
          className={clsx('slate-media', `slate-media--align-${align}`)}
          style={figureStyle}
        >
          <div
            className="slate-embed--rendered"
            style={wrapperStyle}
          >
            <iframe
              {...data}
              style={style}
              src={embedUrl}
              title="embed"
              frameBorder={0}
              allowFullScreen
            />
          </div>
          {caption?.length > 0 && (
            <figcaption
              style={{ width }}
            >
              {caption[0].text}
            </figcaption>
          )}
        </figure>
      );
    },
  }),
};
